import { useState } from 'react';

type UseCategoriesListReturn = {
  isExpanded: boolean;
  viewAllItems: () => void;
};

export const useCategoriesList = (): UseCategoriesListReturn => {
  const [isExpanded, setIsExpanded] = useState(false);

  const viewAllItems = (): void => {
    setIsExpanded(true);
  };

  return {
    isExpanded,
    viewAllItems,
  };
};
